import { GraphEdge } from "./GraphEdge.interface";
import { GraphNode } from "./GraphNode.interface";

export interface GraphDataset {
    nodes: GraphNode[];
    edges: GraphEdge[];
}

export class GraphDatasetManager {
    static addNeighbours(path: GraphDataset, all: GraphDataset) {
        const copy = JSON.parse(JSON.stringify(path)) as GraphDataset;
        const channelIds = path.edges.map(edge => edge.id);
        for (const node of path.nodes) {
            const adjEdges = this.getAdjEdges(node, all);
            for (const edge of adjEdges) {
                if (channelIds.indexOf(edge.id) > -1) {
                    continue
                }
                copy.edges.push(edge);
                channelIds.push(edge.id);
            }
        }
        const nodeIds = path.nodes.map(node => node.id);
        for (const edge of copy.edges) {
            const node = this.getNode(edge.target, all);
            if (nodeIds.indexOf(node.id) > -1) {
                continue;
            }
            copy.nodes.push(node);
            nodeIds.push(node.id);
        }

        return copy;
    }

    static getAdjEdges(node: GraphNode, all: GraphDataset): Array<GraphEdge> {
        return all.edges.filter(edge => {
            return edge.source == node.id;
        })
    }

    static getNode(nodeId: string, all: GraphDataset): GraphNode {
        return all.nodes.filter(node => node.id === nodeId)[0];
    }
}